import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import { createElement as _createElement } from "react";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useToken } from '@ant-design/pro-utils';
import { Avatar, ConfigProvider, Layout, Menu, Space } from 'antd';
import classNames from 'classnames';
import { useContext, useMemo } from 'react';
import { ProLayoutContext } from '../../context/ProLayoutContext';
import { AppsLogoComponents, defaultRenderLogo } from '../AppsLogoComponents';
import { CollapsedIcon } from '../CollapsedIcon';
import { BaseMenu } from './BaseMenu';
import { MenuCounter } from './Counter';
var Sider = Layout.Sider;
/**
 * 渲染 title 和 logo
 *
 * @param props
 * @param renderKey
 * @returns
 */

export var renderLogoAndTitle = function renderLogoAndTitle(props) {
  var renderKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'menuHeaderRender';
  var logo = props.logo,
      title = props.title,
      layout = props.layout;
  var renderFunction = props[renderKey || ''];

  if (renderFunction === false) {
    return null;
  }

  var logoDom = defaultRenderLogo(logo);

  var titleDom = _jsx("h1", {
    children: title !== null && title !== void 0 ? title : 'Ant Design Pro'
  });

  if (renderFunction) {
    // when collapsed, no render title
    return renderFunction(logoDom, props.collapsed ? null : titleDom, props);
  }
  /**
   * 收起来时候直接不显示
   */


  if (props.isMobile) {
    return null;
  }

  if (layout === 'mix' && renderKey === 'menuHeaderRender') return false;

  if (props.collapsed) {
    return _jsx("a", {
      children: logoDom
    }, "title");
  }

  return _jsxs("a", {
    children: [logoDom, titleDom]
  }, "title");
};

var SiderMenu = function SiderMenu(props) {
  var _classNames, _props$menu2;

  var collapsed = props.collapsed,
      originCollapsed = props.originCollapsed,
      fixSiderbar = props.fixSiderbar,
      menuFooterRender = props.menuFooterRender,
      _onCollapse = props.onCollapse,
      theme = props.theme,
      siderWidth = props.siderWidth,
      isMobile = props.isMobile,
      onMenuHeaderClick = props.onMenuHeaderClick,
      _props$breakpoint = props.breakpoint,
      breakpoint = _props$breakpoint === void 0 ? 'lg' : _props$breakpoint,
      style = props.style,
      layout = props.layout,
      _props$menuExtraRende = props.menuExtraRender,
      menuExtraRender = _props$menuExtraRende === void 0 ? false : _props$menuExtraRende,
      links = props.links,
      menuContentRender = props.menuContentRender,
      collapsedButtonRender = props.collapsedButtonRender,
      prefixCls = props.prefixCls,
      avatarProps = props.avatarProps,
      rightContentRender = props.rightContentRender,
      actionsRender = props.actionsRender,
      onOpenChange = props.onOpenChange,
      logoStyle = props.logoStyle;

  var _useToken = useToken(),
      hashId = _useToken.hashId;

  var showSiderExtraDom = useMemo(function () {
    if (isMobile) return false;
    if (layout === 'mix') return false;
    return true;
  }, [isMobile, layout]);
  var baseClassName = "".concat(prefixCls, "-sider");

  var _MenuCounter$useConta = MenuCounter.useContainer(),
      flatMenuKeys = _MenuCounter$useConta.flatMenuKeys;

  var siderClassName = classNames("".concat(baseClassName), hashId, (_classNames = {}, _defineProperty(_classNames, "".concat(baseClassName, "-fixed"), fixSiderbar), _defineProperty(_classNames, "".concat(baseClassName, "-collapsed"), props.collapsed), _defineProperty(_classNames, "".concat(baseClassName, "-layout-").concat(layout), layout && !isMobile), _defineProperty(_classNames, "".concat(baseClassName, "-light"), theme !== 'dark'), _defineProperty(_classNames, "".concat(baseClassName, "-mix"), layout === 'mix' && !isMobile), _classNames));
  var headerDom = renderLogoAndTitle(props);
  var extraDom = menuExtraRender && menuExtraRender(props);
  var menuDom = useMemo(function () {
    return menuContentRender !== false && flatMenuKeys && /*#__PURE__*/_createElement(BaseMenu, _objectSpread(_objectSpread({}, props), {}, {
      key: "base-menu",
      mode: "inline",
      handleOpenChange: onOpenChange,
      style: {
        width: '100%'
      },
      className: "".concat(baseClassName, "-menu ").concat(hashId)
    }));
  }, [baseClassName, flatMenuKeys, hashId, menuContentRender, onOpenChange, props]);
  var linksMenuItems = (links || []).map(function (node, index) {
    return {
      className: "".concat(baseClassName, "-link"),
      label: node,
      key: index
    };
  });
  var menuRenderDom = useMemo(function () {
    return menuContentRender ? menuContentRender(props, menuDom) : menuDom;
  }, [menuContentRender, menuDom, props]);
  var avatarDom = useMemo(function () {
    return avatarProps && _jsxs(Space, {
      align: "center",
      className: "".concat(baseClassName, "-actions-avatar"),
      children: [_jsx(Avatar, _objectSpread({
        size: 28
      }, avatarProps)), avatarProps.title && !collapsed && _jsx("span", {
        children: avatarProps.title
      })]
    });
  }, [avatarProps, baseClassName, collapsed]);
  var actionsDom = useMemo(function () {
    if (!actionsRender) return null;
    return _jsx(Space, {
      align: "center",
      size: 4,
      direction: collapsed ? 'vertical' : 'horizontal',
      className: classNames(["".concat(baseClassName, "-actions-list"), collapsed && "".concat(baseClassName, "-actions-list-collapsed"), hashId]),
      children: actionsRender === null || actionsRender === void 0 ? void 0 : actionsRender(props).map(function (item, index) {
        return _jsx("div", {
          className: "".concat(baseClassName, "-actions-list-item ").concat(hashId),
          children: item
        }, index);
      })
    });
  }, // eslint-disable-next-line react-hooks/exhaustive-deps
  [actionsRender, baseClassName, collapsed]);
  var appsDom = useMemo(function () {
    return _jsx(AppsLogoComponents, {
      appList: props.appList,
      prefixCls: props.prefixCls
    });
  }, [props.appList, props.prefixCls]);
  var collapsedDom = useMemo(function () {
    if (collapsedButtonRender === false) return null;

    var dom = _jsx(CollapsedIcon, {
      isMobile: isMobile,
      collapsed: originCollapsed,
      className: "".concat(baseClassName, "-collapsed-button"),
      onClick: function onClick() {
        _onCollapse === null || _onCollapse === void 0 ? void 0 : _onCollapse(!originCollapsed);
      }
    });

    if (collapsedButtonRender) return collapsedButtonRender(collapsed, dom);
    return dom;
  }, [collapsedButtonRender, isMobile, originCollapsed, baseClassName, collapsed, _onCollapse]);
  /** 操作区域的dom */

  var actionAreaDom = useMemo(function () {
    if (!avatarDom && !actionsDom) return null;
    return _jsxs("div", {
      className: classNames("".concat(baseClassName, "-actions"), hashId, collapsed && "".concat(baseClassName, "-actions-collapsed")),
      children: [avatarDom, actionsDom]
    });
  }, [actionsDom, avatarDom, baseClassName, collapsed, hashId]);
  var collapsedWidth = 60;
  /* Using the useMemo hook to create a CSS class that will hide the menu when the menu is collapsed. */

  var hideMenuWhenCollapsedClassName = useMemo(function () {
    var _props$menu;

    // 收起时完全隐藏菜单
    if ((props === null || props === void 0 ? void 0 : (_props$menu = props.menu) === null || _props$menu === void 0 ? void 0 : _props$menu.hideMenuWhenCollapsed) && collapsed) {
      return "".concat(baseClassName, "-hide-menu-collapsed");
    }

    return null;
  }, [baseClassName, collapsed, props === null || props === void 0 ? void 0 : (_props$menu2 = props.menu) === null || _props$menu2 === void 0 ? void 0 : _props$menu2.hideMenuWhenCollapsed]);
  var menuFooterDom = menuFooterRender && (menuFooterRender === null || menuFooterRender === void 0 ? void 0 : menuFooterRender(props));

  var menuDomItems = _jsxs(_Fragment, {
    children: [headerDom && _jsxs("div", {
      className: classNames([classNames("".concat(baseClassName, "-logo"), hashId, _defineProperty({}, "".concat(baseClassName, "-logo-collapsed"), collapsed))]),
      onClick: showSiderExtraDom ? onMenuHeaderClick : undefined,
      id: "logo",
      style: logoStyle,
      children: [headerDom, appsDom]
    }), extraDom && _jsx("div", {
      className: classNames(["".concat(baseClassName, "-extra"), !headerDom && "".concat(baseClassName, "-extra-no-logo"), hashId]),
      children: extraDom
    }), _jsx("div", {
      style: {
        flex: 1,
        overflowY: 'auto',
        overflowX: 'hidden'
      },
      children: menuRenderDom
    }), links ? _jsx("div", {
      className: "".concat(baseClassName, "-links ").concat(hashId),
      children: _jsx(Menu, {
        inlineIndent: 16,
        className: "".concat(baseClassName, "-link-menu ").concat(hashId),
        selectedKeys: [],
        openKeys: [],
        theme: "light",
        mode: "inline",
        items: linksMenuItems
      })
    }) : null, showSiderExtraDom && _jsxs(_Fragment, {
      children: [actionAreaDom, rightContentRender ? _jsx("div", {
        className: classNames("".concat(baseClassName, "-actions"), hashId, _defineProperty({}, "".concat(baseClassName, "-actions-collapsed"), collapsed)),
        children: rightContentRender === null || rightContentRender === void 0 ? void 0 : rightContentRender(props)
      }) : null]
    }), menuFooterDom && _jsx("div", {
      className: classNames(["".concat(baseClassName, "-footer"), hashId, _defineProperty({}, "".concat(baseClassName, "-footer-collapsed"), collapsed)]),
      children: menuFooterDom
    })]
  });

  var _useContext = useContext(ProLayoutContext),
      sider = _useContext.sider;

  return _jsxs(_Fragment, {
    children: [fixSiderbar && !isMobile && !hideMenuWhenCollapsedClassName && _jsx("div", {
      style: _objectSpread({
        width: collapsed ? collapsedWidth : siderWidth,
        overflow: 'hidden',
        flex: "0 0 ".concat(collapsed ? collapsedWidth : siderWidth, "px"),
        maxWidth: collapsed ? collapsedWidth : siderWidth,
        minWidth: collapsed ? collapsedWidth : siderWidth,
        transition: 'all 0.2s ease 0s'
      }, style)
    }), _jsxs(Sider, {
      collapsible: true,
      trigger: null,
      collapsed: collapsed,
      breakpoint: breakpoint === false ? undefined : breakpoint,
      onCollapse: function onCollapse(collapse) {
        if (isMobile) return;
        _onCollapse === null || _onCollapse === void 0 ? void 0 : _onCollapse(collapse);
      },
      collapsedWidth: collapsedWidth,
      style: style,
      theme: "light",
      width: siderWidth,
      className: classNames(siderClassName, hashId, hideMenuWhenCollapsedClassName),
      children: [_jsx(ConfigProvider // @ts-ignore
      , {
        // @ts-ignore
        theme: {
          hashed: false,
          override: {
            Menu: {
              radiusItem: 4,
              colorItemBgSelected: sider.colorBgMenuItemSelected || 'rgba(0, 0, 0, 0.04)',
              colorItemBgActive: sider.colorBgMenuItemHover || 'rgba(0, 0, 0, 0.04)',
              colorActiveBarWidth: 0,
              colorActiveBarHeight: 0,
              colorActiveBarBorderSize: 0,
              colorItemText: sider.colorTextMenu || 'rgba(0, 0, 0, 0.65)',
              colorItemTextHover: sider.colorTextMenuActive || 'rgba(0, 0, 0, 0.85)',
              colorItemTextSelected: sider.colorTextMenuSelected || 'rgba(0, 0, 0, 1)',
              colorItemBg: 'transparent',
              colorSubItemBg: 'transparent'
            }
          }
        },
        children: hideMenuWhenCollapsedClassName ? _jsx("div", {
          className: "".concat(baseClassName, "-hide-when-collapsed ").concat(hashId),
          style: {
            height: '100%',
            width: '100%',
            opacity: hideMenuWhenCollapsedClassName ? 0 : 1
          },
          children: menuDomItems
        }) : menuDomItems
      }), collapsedDom]
    })]
  });
};

export { SiderMenu };